import React, { FC } from 'react'
import * as tailwindConfigModule from '@tailwind-config'

interface ColorFilterProps {
  color: string
}

const ImageColorByFilter: FC<ColorFilterProps> = ({ color }) => {
  const tailwindConfig = ('default' in tailwindConfigModule ? tailwindConfigModule.default : tailwindConfigModule) as {
    theme?: { colors?: Record<string, string> }
  }
  const colorHexWithHash = tailwindConfig.theme?.colors?.[color]
  const colorHex = colorHexWithHash?.replace('#', '')
  const getColorValue = (start: number) =>
    colorHex ? (parseInt(colorHex.slice(start, start + 2), 16) / 255).toFixed(2) : '0.0'

  const red = getColorValue(0)
  const green = getColorValue(2)
  const blue = getColorValue(4)

  return (
    <svg
      aria-hidden
      style={{
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <defs>
        <filter id={`colorFilter-${color}`} colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values={`
              0 0 0 0 ${red}
              0 0 0 0 ${green}
              0 0 0 0 ${blue}
              0 0 0 1 0
          `}
          />
        </filter>
      </defs>
    </svg>
  )
}

export default ImageColorByFilter
